import baseURLv1 from '@/services/APIConfig.js';
import { add, append, remove, set, update } from '@/vuex/helpers';

export default {
  namespaced: true,
  state: {
    isLoading: false,
    users: [],
    allUsers: [],
    filters: {
      is_active: null,
      order_by: 'fullname',
      search: '',
      page: 1,
      page_size: 10,
    },
    previous: null,
    next: null,
  },
  mutations: {
    set,
    update,
    add,
    remove,
    append,
    updateFilter(state, { field, payload }) {
      state.filters[field] = payload;
      if (field !== 'page') {
        state.filters.page = 1;
      }
    },
  },
  actions: {
    async addInternalUser({ commit }, { payload }) {
      // BE wants profile field to be present, otherwise will receive 409 response
      const company = await this.$axios.post(`${baseURLv1}/user/internal/`, { ...payload, profile: {} });
      commit('add', ['users', company.data.data]);
    },

    async editUser({ commit }, { user, id }) {
      const response = await this.$axios.patch(`${baseURLv1}/user/internal/${id}/`, user);

      commit('update', ['users', { id, payload: response.data.data }]);
    },

    async getUserDetails({ commit }, { id }) {
      const response = await this.$axios.get(`${baseURLv1}/user/internal/${id}/`);

      return response.data.data;
    },

    async deleteUser({ commit }, id ) {
      const response = await this.$axios.delete(`${baseURLv1}/user/internal/${id}/`);

      commit('remove', ['users', id]);
      return response.data.data;
    },

    async uploadUserAvatar({ commit }, { id, avatar }) {
      const fd = new FormData();

      fd.append('file', avatar);
      await this.$axios.post(`${baseURLv1}/user/internal/${id}/avatar/`, fd, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });
    },

    async load({ state, commit }) {
      commit('set', ['isLoading', true]);
      const response = await this.$axios.get(`${baseURLv1}/user/internal/`, {
        params: {
          ...state.filters,
        },
      });

      commit('set', ['users', response.data.data]);
      commit('set', ['previous', response.data.previous]);
      commit('set', ['next', response.data.next]);
      commit('set', ['isLoading', false]);
    },
    async loadAllUsers({ _, commit }) {
      const response = await this.$axios.get(`${baseURLv1}/user/internal/`, {
        params: {
          page: 1,
          page_size: 1000,
        },
      });

      commit('set', ['allUsers', response.data.data]);
    },
  },
  getters: {
    selectOptions: (state) =>
      state.allUsers
        .filter((el) => el.is_active),
    selectOptionsAreEmpty: (state) => state.allUsers.length === 0,
  },
};
